module.exports = __webpack_public_path__ + "img/full0-min.5bb2bdf9.png";